import { SavedBeneficiary } from '../../pages';
import { useStores } from '../../stores';
import React from 'react';
import * as yup from 'yup';

const SavedBeneficiaryContainer = ({
	beneficiaryList,
	transferSwitchState,
	selectedState,
	setShowSurvey,
}) => {
	const { walletStore } = useStores();
	const validationSchema = () => {
		return yup.object({
			transactionAmount: yup
				.number()
				.min(100, 'Amount Should be greater than 100.00'),
			beneficiary: yup.object().optional(),
			expenseCategory: yup.string().required('Expense Category is required'),
			narration: yup.string().required('Description is required'),
		});
	};

	const onSubmit = payload => {
		if (selectedState.value !== '-Select-') {
			payload.currencyCode = 'NGN';
			payload.saveBeneficiary = false;
			payload.beneficiaryAccountNumber = payload.beneficiary.accountNumber;
			payload.accountName = payload.beneficiary.accountName;
			payload.beneficiaryBank = payload.beneficiary.bankCode;
			delete payload.beneficiary;
			walletStore.setTransferPayload(payload);
			return transferSwitchState.goToConfirmPin();
		}
	};

	return (
		<SavedBeneficiary
			beneficiaryList={beneficiaryList}
			selectedState={selectedState}
			onSubmit={onSubmit}
			validationSchema={validationSchema}
		/>
	);
};

export default SavedBeneficiaryContainer;
